import * as React from 'react';
import { Button, Card, Dropdown, Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import { getNextStep, getOverview } from '../../../../actions/claimHistoryActionsV2'
import ClaimsProgressBar from '../ClaimHistoryComponents/ClaimsProgressBar';
import { HashLink as Link } from 'react-router-hash-link';
import { CLAIM_HISTORY_V2, GOOGLE_MAPS_BASE_URL } from '../../../../routes/routes';
import { isMobile } from 'react-device-detect';
import AddToCalendarHOC from 'react-add-to-calendar-hoc';
import moment from 'moment';
import '././ClaimHistorySteps.css'
import { hideModal } from "../../../../actions/modalActions";
import { navigateTo } from '../../../../actions/navigationActions';
import ClaimsNextStep from '../ClaimHistoryComponents/ClaimsNextStep';

class Assesment extends React.Component<any, any> {

    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
        this.getFormatAssesmentDate = this.getFormatAssesmentDate.bind(this);
        this.handleHideModal = this.handleHideModal.bind(this);
        this.handleCalendarClick = this.handleCalendarClick.bind(this);
        this.handleBackClick = this.handleBackClick.bind(this);
        this.handleDirectionsClick = this.handleDirectionsClick.bind(this);
    }

    async handleBackClick() {
        this.props.handleClaimsBackClick();
    }

    handleCalendarClick(e: any) {
        if (e.key == "iCal") {
            document.getElementById("1")!.children[0].setAttribute('id', e.key);
            document.getElementById(e.key)!.click();
        } else
            if (e.key == "Outlook") {
                document.getElementById("2")!.children[0].setAttribute('id', e.key);
                document.getElementById(e.key)!.click();
            }
            else {
                window.open(
                    e.props.href,
                    '_blank'
                );
            }
    }

    handleDirectionsClick() {
        var url = GOOGLE_MAPS_BASE_URL;
        window.open(GOOGLE_MAPS_BASE_URL + this.props.claimSubmit.selectedClaimProgressStep.claimAssessmentStep.assessmentCentreLat + ',' + this.props.claimSubmit.selectedClaimProgressStep.claimAssessmentStep.assessmentCentreLong, '_blank');
    }

    handleHideModal(e: any) {
        this.props.dispatchHideModal();
    }

    async handleClick() {
        this.props.handleGetNextStep();
    }

    getFormatAssesmentDate(date: string) {
        if (date) {
            const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
            var stringDate = date.split('T')[0];
            var formatedDate = new Date(stringDate);
            var fullFormatedDate = formatedDate.getDate().toString() + " " + monthNames[formatedDate.getMonth()] + " " + formatedDate.getFullYear().toString();
            return fullFormatedDate;
        } else {
            return "Not Found";
        }
    }

    render() {
        const ATCDropdown = (args) => (
            <Modal show={true} backdrop="static" keyboard={false} centered animation={false} className="add-to-calendar">
                <Modal.Header className="col-12 text-center no-border">
                    <Modal.Title className="w-100">
                        <div className="float-right mb-4px">
                            <button className="btn-modal-close" onClick={this.handleHideModal}><img src="./images/icons-navigation-close-16-px-dark-grey.svg" alt="close" title="close" /></button>
                        </div>
                        <img src="/my-policy/Images/Calendar.png" alt="" title="" className="add-to-calendar-icon" />
                        <p className="calendarHeading mb-30px">Add to calendar</p>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row noma">
                        {args.children.map((link, i) => (
                            <div onClick={() => this.handleCalendarClick(link)} id={i} key={i} className="mb-20px col-12 calendarTile text-center">{link}</div>
                        ))}
                    </div>
                    <hr className="add-to-calender-hr" />
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-solid-red full-width add-to-calendar-cancel-button" onClick={this.handleHideModal} id='closeModal'>Cancel</button>
                </Modal.Footer>
            </Modal>
        );

        const ATCWrapper = (args) => (
            <button onClick={args.onClick} className="atc-item btn btn-solid-green claims-green-btn text-white">
                {/*{args.children}*/}Add to calendar
            </button>
        );

        const AddToCalendarModal = AddToCalendarHOC(ATCWrapper, ATCDropdown);
        const startDatetime = new Date(this.props.claimSubmit.selectedClaimProgressStep.claimAssessmentStep.assessmentDate);
        const endDatetime = new Date(this.props.claimSubmit.selectedClaimProgressStep.claimAssessmentStep.assessmentDate);
        const durationTime = startDatetime.getHours() - endDatetime.getHours();
        const event = {
            title: "Assessment",
            description: "Damage assessment",
            location: this.props.claimSubmit.selectedClaimProgressStep.claimAssessmentStep.physicalAddressLine1 + this.props.claimSubmit.selectedClaimProgressStep.claimAssessmentStep.physicalAddressLine2,
            duration: durationTime,
            endDatetime: moment(endDatetime).format("YYYYMMDDTHHmmss"),
            startDatetime: moment(startDatetime).format("YYYYMMDDTHHmmss"),
            dtstamp: new Date()
        };

        const scrollWithOffset = (el) => {
            const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
            const yOffset = -90;
            window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' });
        }
        const stepsList = this.props.claimSubmit.claimProgress.claimSteps.filter(x => x.overallEstProgressBar !== null).length > 0
        let nrToUse = -1
        if (this.props.claimSubmit.claimProgress) {
            for (var i = 0; i < this.props.claimSubmit.claimProgress.claimSteps.length - 1; i++) {
                if (this.props.claimSubmit.claimProgress.claimSteps[i + 1].claimStepDescription.toLowerCase() !== this.props.claimSubmit.claimProgress.claimSteps[i].claimStepDescription.toLowerCase()) {
                    nrToUse += 1
                    if (this.props.claimSubmit.claimProgress.claimSteps[i].claimStepDescription.toLowerCase() === this.props.claimSubmit.selectedClaimProgressStep.claimStepDescription.toLowerCase()) {
                        break;
                    }
                }
            }
        }
        let totalPay = 0
        let totalDamage = this.props.claimSubmit.selectedClaimProgressStep.claimAssessmentStep.totalDamageAmount ?? 0
        let basicExcess = this.props.claimSubmit.selectedClaimProgressStep.claimAssessmentStep.basicExcess ?? 0
        let additionalExcess = this.props.claimSubmit.selectedClaimProgressStep.claimAssessmentStep.additionalExcess ?? 0
        let otherContributions = this.props.claimSubmit.selectedClaimProgressStep.claimAssessmentStep.otherContributions ?? 0
        totalPay = (totalDamage - basicExcess - additionalExcess - otherContributions)
        const claimStepDescription = this.props.claimSubmit.selectedClaimProgressStep.claimStepDescription.toLowerCase();
        const claimStep = this.props.claimSubmit.claimProgress.claimSteps.filter(x => x.claimStepDescription.toLowerCase() === claimStepDescription)[0];
        return (
            <>
                <button className="claims-back-button" onClick={this.handleBackClick}> <img className="claims-back-button-img" src="/my-policy/Images/Claims/ClaimsV2/Dropdown-arrow-left.png" alt="" title="" />Back</button>
                <div id="ClaimOverView">
                    {stepsList && !this.props.claimSubmit.selectedClaimProgressStep.isComplete && claimStepDescription && (claimStep.overallEstCompletionDate || claimStep.overallEstLatestDate) &&
                        <Card className="content-box-padding-20px-with-box-shadow mb-15px">
                            <div className="row noma">
                                <div className="col-12 nopa">
                                    <ClaimsProgressBar />
                                </div>
                            </div>
                        </Card>
                    }
                    <Card className="content-box-padding-20px-with-box-shadow">
                        <div className="row noma">
                            <div className="col-12 nopa">
                                <div className="row noma">
                                    <div className="claims-noc-step-header-icon-area">
                                        {(!this.props.claimSubmit.selectedClaimProgressStep.isComplete) && <img src={"/my-policy/Images/Claims/Numbers/" + nrToUse + "-red.png"} alt={"Step " + nrToUse} title={"Step" + nrToUse} />}
                                        {(this.props.claimSubmit.selectedClaimProgressStep.isComplete) && <img src="/my-policy/Images/Claims/Numbers/step-success-32x32px.svg" alt="Step 4: Completed" title="Step 4: Completed" />}
                                    </div>
                                    <div className="col nopa claims-noc-step-header-title-area">
                                        <h3>Assessment</h3>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 nopa mt-10px">
                                {(this.props.claimSubmit.selectedClaimProgressStep.isComplete && (this.props.claimSubmit.selectedClaimProgressStep.claimType === "Motor Vehicle Repair Driveable" || this.props.claimSubmit.selectedClaimProgressStep.claimType === "Motor Vehicle Repair Non-Driveable")) && <p className="font-weight-500 mb-0px">Damage assessment = done. You can have a look at the next step.</p>}
                                {(this.props.claimSubmit.selectedClaimProgressStep.isComplete && this.props.claimSubmit.selectedClaimProgressStep.claimType === "Motor Vehicle W/O") && <p className="font-weight-500 mb-0px">Damage assessment = done. You can have a look at the next step.<br /><br /></p>}
                                {((this.props.claimSubmit.claimProgress && !this.props.claimSubmit.selectedClaimProgressStep.isComplete)) && <p className="font-weight-500 mb-0px">Let's take a look at your car's damage, shall we.<br /><br />
                                    {!isMobile &&
                                        <span>Scroll down to the<Link className="text-red" to={CLAIM_HISTORY_V2 + "#claimFAQ"} scroll={el => scrollWithOffset(el)}> <b className="text-underline">FAQ’s</b></Link> for more info.</span>
                                    }
                                    {isMobile &&
                                        <span>Scroll down to the<Link className="text-red"> <b>FAQ’s</b></Link> for more info.</span>
                                    }
                                </p>}
                                <hr className="mt-15px mb-15px claims-v2-hr-2px" />
                            </div>
                            <div className="col-12 nopa">
                                <div className="row noma">
                                    <div className="col-12 nopa">
                                        <p className="card-subheading mb-0px">Where we’re at</p>
                                    </div>
                                    {(!this.props.claimSubmit.selectedClaimProgressStep.isComplete && this.props.claimSubmit.selectedClaimProgressStep.claimRepairProcessSub === "Assessment Arranged") && <div className="mt-10px">
                                        <p className="text-16 text-red mb-15px">We’ve arranged for your car to be assessed</p>
                                        <p className="font-weigtht-500 mb-0px">High-5, we're about to assess your car... Which means we should have the damage report soon</p>
                                    </div>}
                                    {(this.props.claimSubmit.selectedClaimProgressStep.isComplete) && <div className="mt-10px">
                                        <p className="font-size-16px text-red mb-15px">Your damage assessment = done</p>
                                        <p className="font-weigtht-500 mb-0px">Whoop, your car's been assessed and we've received its damage report</p>
                                    </div>}
                                </div>
                                <hr className="mt-15px mb-15px claims-v2-hr-2px" />
                            </div>
                            {(!this.props.claimSubmit.selectedClaimProgressStep.isComplete && this.props.claimSubmit.selectedClaimProgressStep.claimAssessmentStep.assessmentDate && this.props.claimSubmit.selectedClaimProgressStep.claimRepairProcessSub === "Assessment Arranged") &&
                                <div className="col-12 assessment-section-holder">
                                    <div className="row noma assessment-parent-row">
                                        <div className="col nopa">
                                            <p className="card-subheading mb-0px">Assessment date</p>
                                        </div>
                                        <div className="nopa text-lg-right assessment-col">
                                            <p className="text-red mb-0px">{this.getFormatAssesmentDate(this.props.claimSubmit.selectedClaimProgressStep.claimAssessmentStep.assessmentDate)}</p>
                                        </div>
                                    </div>
                                    <div className="row noma mt-19px">
                                        <div className="col nopa text-right">
                                            <AddToCalendarModal linkProps={{ className: 'calendarText', }} event={event} />
                                        </div>
                                    </div>
                                    <hr className={!isMobile ? "mt-17px mb-15px claims-v2-hr-2px" : "mt-20px mb-15px claims-v2-hr-2px"} />
                                </div>
                            }
                            {(!this.props.claimSubmit.selectedClaimProgressStep.isComplete && this.props.claimSubmit.selectedClaimProgressStep.claimRepairProcessSub === "Assessment Arranged") && <div className="col-12 assessment-section-holder">
                                <div className="row noma">
                                    <div className="col nopa">
                                        <p className="card-subheading mb-0px">Assessment centre</p>
                                    </div>
                                    <div className="nopa text-lg-right assessment-col">
                                        {this.props.claimSubmit.selectedClaimProgressStep.claimAssessmentStep.assessmentCentre && <p className="text-red mb-12px">{this.props.claimSubmit.selectedClaimProgressStep.claimAssessmentStep.assessmentCentre}</p>}
                                        {this.props.claimSubmit.selectedClaimProgressStep.claimAssessmentStep.physicalAddressLine1 && <p className="mb-0px">{this.props.claimSubmit.selectedClaimProgressStep.claimAssessmentStep.physicalAddressLine1}</p>}
                                        {this.props.claimSubmit.selectedClaimProgressStep.claimAssessmentStep.physicalAddressLine2 && <p className="mb-0px">{this.props.claimSubmit.selectedClaimProgressStep.claimAssessmentStep.physicalAddressLine2}</p>}
                                        {this.props.claimSubmit.selectedClaimProgressStep.claimAssessmentStep.assessmentCentreContactNumber && <p className="mb-0px">{this.props.claimSubmit.selectedClaimProgressStep.claimAssessmentStep.assessmentCentreContactNumber}</p>}
                                        {this.props.claimSubmit.selectedClaimProgressStep.claimAssessmentStep.assessmentCentreEmail && <p className="mb-0px line-height-normal"><a href={this.props.claimSubmit.selectedClaimProgressStep.claimAssessmentStep.assessmentCentreEmail} target="_blank" className="email">{this.props.claimSubmit.selectedClaimProgressStep.claimAssessmentStep.assessmentCentreEmail}</a></p>}
                                    </div>
                                </div>
                                {this.props.claimSubmit.selectedClaimProgressStep.claimAssessmentStep.assessmentCentreLat && this.props.claimSubmit.selectedClaimProgressStep.claimAssessmentStep.assessmentCentreLong && <div className="row noma mt-18px">
                                    <div className="col nopa text-right">
                                        <button className="btn btn-solid-green claims-green-btn" onClick={this.handleDirectionsClick}>Get directions</button>
                                    </div>
                                </div>}
                                <hr className="mt-15px mb-15px claims-v2-hr-2px" />
                            </div>}
                            {(this.props.claimSubmit.selectedClaimProgressStep.isComplete && this.props.claimSubmit.selectedClaimProgressStep.claimType === "Motor Vehicle W/O") && <div className="col-12 assessment-section-holder">
                                <div className="row noma assessment-parent-row">
                                    <div className="col-12 nopa">
                                        <p className="card-subheading mb-0px">Assessment outcome</p>
                                    </div>
                                    <div className="nopa mt-15px">
                                        <p className="font-weight-500 mb-0px">Unfortunately, it’s not economical for us to repair your car… We’ll chat to you soon to explain everything</p>
                                    </div>
                                </div>
                                <hr className={!isMobile ? "mt-15px mb-15px claims-v2-hr-2px" : "mt-20px mb-20px claims-v2-hr-2px"} />
                            </div>}
                            {(this.props.claimSubmit.selectedClaimProgressStep.isComplete && (this.props.claimSubmit.selectedClaimProgressStep.claimType === "Motor Vehicle Repair Driveable" || this.props.claimSubmit.selectedClaimProgressStep.claimType === "Motor Vehicle Repair Non-Driveable")) &&
                                <div className="col-12 assessment-section-holder">
                                    <div className="row noma assessment-parent-row">
                                        <div className="col nopa">
                                            <p className="card-subheading mb-0px">Damage amount</p>
                                        </div>
                                        <div className="nopa text-lg-right assessment-col">
                                            <p className="font-weight-500 assessment-damage-amount text-red mb-0px"><b>{this.props.profile.currencySymbol}&nbsp;{(this.props.claimSubmit.selectedClaimProgressStep.claimAssessmentStep.totalDamageAmount === null ? "0.00" : this.props.claimSubmit.selectedClaimProgressStep.claimAssessmentStep.totalDamageAmount.toFixed(2))}</b></p>
                                        </div>
                                    </div>
                                    <hr className={!isMobile ? "mt-15px mb-15px claims-v2-hr-2px" : "mt-20px mb-20px claims-v2-hr-2px"} />
                                </div>}
                            {(this.props.claimSubmit.selectedClaimProgressStep.isComplete && (this.props.claimSubmit.selectedClaimProgressStep.claimType === "Motor Vehicle Repair Driveable" || this.props.claimSubmit.selectedClaimProgressStep.claimType === "Motor Vehicle Repair Non-Driveable")) &&
                                <div className="col-12 nopa">
                                    <div className="row noma">
                                        <div className="col nopa">
                                            <p className="card-subheading text-bold">Excess breakdown</p>
                                        </div>
                                    </div>
                                    <div className="row noma mb-10px">
                                        <div className="col nopa">
                                            <p className="font-weight-500 mb-0px">Basic excess</p>
                                        </div>
                                        <div>
                                            <p className="text-right text-bold mb-0px">- {this.props.profile.currencySymbol}&nbsp;{(this.props.claimSubmit.selectedClaimProgressStep.claimAssessmentStep.basicExcess === null ? "0.00" : this.props.claimSubmit.selectedClaimProgressStep.claimAssessmentStep.basicExcess.toFixed(2))}</p>
                                        </div>
                                    </div>
                                    <div className="row noma mb-10px">
                                        <div className="col nopa text-left">
                                            <p className="font-weight-500 mb-0px">Additional excess/es</p>
                                        </div>
                                        <div>
                                            <p className="text-right text-bold mb-0px">- {this.props.profile.currencySymbol}&nbsp;{(this.props.claimSubmit.selectedClaimProgressStep.claimAssessmentStep.additionalExcess === null ? "0.00" : this.props.claimSubmit.selectedClaimProgressStep.claimAssessmentStep.additionalExcess.toFixed(2))}</p>
                                        </div>
                                    </div>
                                    <div className="row noma">
                                        <div className="col nopa text-left">
                                            <p className="font-weight-500 mb-0px">Other contribution/s</p>
                                        </div>
                                        <div>
                                            <p className="text-right text-bold mb-0px">- {this.props.profile.currencySymbol}&nbsp;{(this.props.claimSubmit.selectedClaimProgressStep.claimAssessmentStep.otherContributions === null ? "0.00" : this.props.claimSubmit.selectedClaimProgressStep.claimAssessmentStep.otherContributions.toFixed(2))}</p>
                                        </div>
                                    </div>
                                <hr className="mt-15px mb-15px claims-v2-hr-2px" />
                                <div className="row noma">
                                    <div className="col nopa text-left">
                                        <p className="card-subheading text-bold">We'll pay</p>
                                    </div>
                                    <div>
                                        <p className="text-right assessment-damage-amount text-red mb-0px">{this.props.profile.currencySymbol}&nbsp;{(totalPay === 0 ? "0.00" : totalPay.toFixed(2))}</p>
                                    </div>
                                </div>
                                <hr className="mt-15px mb-15px claims-v2-hr-2px" />
                            </div>}
                            <div className="col-12 nopa">
                                <div className="row noma">
                                    <div className="col nopa">
                                        <p className="next-step-subheading mb-0">Next step</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row noma">
                            <div className="col-12 nopa">
                                <ClaimsNextStep />
                            </div>
                        </div>
                    </Card>
                </div>
            </>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        firebase: state.firebase,
        profile: state.profile,
        claimSubmit: state.claimSubmit,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        handleGetNextStep: () => dispatch(getNextStep()),
        dispatchHideModal: () => dispatch(hideModal()),
        handleNavigateTo: (destination) => dispatch(navigateTo(destination)),
        handleClaimsBackClick: () => dispatch(getOverview()),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(Assesment);
